var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.062 4.404h-.723V2.26c0-.794-.651-1.448-1.447-1.448-.793 0-1.448.656-1.448 1.448v.58h.868v-.58c0-.311.266-.58.58-.58.316 0 .579.263.579.58v2.145H8.354c-1.554 0-2.882-.186-4.376-.613l-2.823-.807a.724.724 0 0 0-.396 1.391l.344.098V7.76a2.9 2.9 0 0 0 2.895 2.894v.316a.724.724 0 1 0 1.447 0v-.316h6.13v.316a.724.724 0 1 0 1.448 0v-.316c1.594 0 2.895-1.3 2.895-2.894V5.852h.144a.724.724 0 1 0 0-1.448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathrooms);
export default __webpack_public_path__ + "static/media/bathrooms.4acbb95ec34127b1210e8d30f3b06c4a.svg";
export { ForwardRef as ReactComponent };